/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Match_By_LabelInputs */



/**
* | output |
* | --- |
* | "Match Events By" |
*
* @param {Metadata_Merge_Match_By_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_match_by_label = /** @type {((inputs?: Metadata_Merge_Match_By_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Match_By_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événements de correspondance par")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spielereignisse von")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi di match")
	if (locale === "ru") return /** @type {LocalizedString} */ ("События матча по")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos de partidos por")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按比赛事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マッチイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मैच इवेंट्स द्वारा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eventos da partida por")
	return /** @type {LocalizedString} */ ("Match Events By")
});